module.exports = __webpack_public_path__ + "img/vsms.c56d85b5.svg";